import Client from "../../../Client";
import "../../../styles/sidebar.css";
import { IconButton } from "../../widgets/buttons";
import { Navigation } from "./Navigation";

function Sidebar({ currentTab, subtab }) {
    return (<div className="sidebar">
        <Header />
        <Navigation currentTab={currentTab} subtab={subtab} />
        <Footer />

    </div>)
}

export default Sidebar;

function Header() {
    return (<header>
        <div className="subtitle">DEPARTMENT OF TOURISM - REGION VIII</div>
        <div className="title">TOURISM STATISTICS REPORTING SYSTEM</div>
    </header>);
}

function Footer() {
    const account = Client.account;
    const roleLabel = {
        guest: "GUEST",
        admin: "ADMIN ACCESS",
        province: "PROVINCE COORDINATOR",
        lgu: "MUN/CITY COORDINATOR",
        reviewer: "REVIEWER",
    }[account.role];
    return (<footer>
        { Client.signedIn ? <div className="account-strip">
            <div className="avatar" />
            <div className="details">
                <div className="account-name">{account.fullname}</div>    
                <div className="account-role">{roleLabel}</div>    
            </div>
            <IconButton icon="exit" size="30" onClick={() => Client.logout()} />
        </div> : "" }
    </footer>)
}